<template>
  <dx-navbar-aside :hidden="hidden">
    <div v-if="!hidden">
      <div class="username">
        <dx-heading>Olá, {{ this.firstName }}!</dx-heading>
      </div>
      <dx-navbar-aside-item description="Minha conta" redirect-page="MeEditData" />
      <dx-navbar-aside-item description="Usuários" redirect-page="AdminUsers" />
      <dx-navbar-aside-item description="Sair" :action="this.logoutAndRedirect" />
      <div class="header dx-margin-top--lg">
      <dx-heading size="sm">Configurações</dx-heading>
    </div>
      <dx-navbar-aside-item description="Fluxos" redirect-page="AdminFlows" />
      <dx-navbar-aside-item description="Atividades" redirect-page="AdminActivities" />

    </div>
    <div
      class="hide-button"
      :class="{'hidden-button': hidden}"
      @click="onClickToggleSidebar"
      @keydown="onClickToggleSidebar">
        {{ hidden ? '>' : '< Esconder' }}
    </div>
  </dx-navbar-aside>
</template>

<script>
import { userService, authService } from '@services';

export default {
  name: 'dx-admin-navbar',

  data() {
    return {
      firstName: userService.getUserDetails().name?.split(' ')[0],
      isAdmin: authService.getGroups().includes('ADMIN'),
      isEntrepreneur: authService.getGroups().includes('ENTREPRENEUR'),
      isRegulator: authService.getGroups().includes('REGULATOR'),
    };
  },

  computed: {
    hidden() {
      return this.$store.getters['sidebar/isSidebarHidden'];
    },
  },

  methods: {
    logoutAndRedirect() {
      authService.logout();
      this.$router.push({ name: 'Logout' });
    },

    onClickToggleSidebar() {
      this.$store.dispatch('sidebar/setSidebarHidden', !this.$store.getters['sidebar/isSidebarHidden']);
    },
  },
};
</script>

<style scoped lang="scss">
.dx-avatar {
  margin: auto;
  display: block;
  margin-top: var(--dx-space-size--md);
  margin-bottom: var(--dx-space-size--sm);
}

.username {
  text-transform: capitalize;
  text-align: center;
  margin-bottom: var(--dx-space-size--sm);
}

.hide-button {
  position: absolute;
  bottom: 0;
  background-color: white;
  border-color: black;
  padding: 10px;
  border-radius: 5px;
  width: 100%;
  color: var(--dx-color--grey);
}

.hide-button:hover {
  cursor: pointer;
  background-color: var(--dx-color--grey-light);
}

.hidden-button {
  position: absolute;
  top: 0;
  width: 32px;
}

.header {
  text-transform: capitalize;
  text-align: center;
  margin-bottom: var(--dx-space-size--sm);
}
</style>
